import React from 'react'

import Svg from './svg'


export default function Week2Icon({width, height, color, color2 = '--accent-color', ...props}) {
    color = getComputedStyle(document.documentElement)
        .getPropertyValue(color || '--on-content') || color
    color2 = getComputedStyle(document.documentElement)
        .getPropertyValue(color2) || color2

    return <Svg width={width || '16px'} height={height || '16px'} viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g id="week2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect id="Rectangle" fill={color2} x="7" y="7" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-3" fill={color2} x="38" y="7" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy" fill={color2} x="7" y="38" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-4" fill={color2} x="38" y="38" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-7" fill={color} x="38" y="69" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-8" fill={color} x="69" y="69" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-6" fill={color2} x="69" y="38" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-2" fill={color2} x="7" y="69" width="24" height="24" rx="8"></rect>
            <rect id="Rectangle-Copy-5" fill={color2} x="69" y="7" width="24" height="24" rx="8"></rect>
        </g>
    </Svg>
}
